import querystring from 'querystring';
import { getUrl } from '../../../src/utils/routeUtils';

export function getRouteQuery(pathname) {
  // const search = root.location.search && root.location.search.slice(1);
  // return search ? querystring.parse(search) : {};
  const search = (pathname || window.location.href)?.split('?');
  if (search?.length > 0) return querystring.parse(search[1]);
  return {};
}

export function replaceQuery(query, keepOnPage = true, skipCheckEdits = false) {
  const queryUrl = querystring.parse(root.location.search.slice(1));

  const queryNotNull = {};
  Object.keys(query).forEach(d => { if (query[d] !== null) queryNotNull[d] = query[d]; });

  const queryUrlNew = {};
  Object.keys(queryUrl).forEach(d => { if (query[d] !== null) queryUrlNew[d] = queryUrl[d]; });

  const to = root?.location?.pathname?.substr?.(1);
  Object.assign(queryUrlNew, queryNotNull);
  const url = getUrl(to, queryUrlNew);

  const cancel = (!skipCheckEdits && root.app?.onUrlChange) ? root.app.onUrlChange(null, queryUrlNew) : false;
  if (cancel) return;

  if (keepOnPage) root.location.replace(url);
  else root.location.push('?' + querystring.stringify(queryUrlNew));
}
